import { render, staticRenderFns } from "./DocumentCreateService.vue?vue&type=template&id=369fa548"
import script from "./DocumentCreateService.vue?vue&type=script&lang=js"
export * from "./DocumentCreateService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports